import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Fab,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

import "react-datepicker/dist/react-datepicker.css";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { getCounterSalesStatement } from "./outstandingApi";
import { useEffect } from "react";

import DisplayOutStandingReport from "./displayOutStandingReport";
import OutStandingReportCart from "./outStandingReportCart";

import {
  convertDateToCustomFormat,
  downloadXLSXFile,
} from "../../utils/commonUtils";
import { api } from "../../utils/api";
import { getCounterSales } from "./outStandingReportCustomApiHandler";
import { displayOutstading } from "./outstandingReportFunction";
import PaymentReceiptSearchModal from "../paymentReceipt/paymentReceiptSearchModal";
import {
  getEmpearningSalary,
  getUnpaidUser,
  viewPaymentSlip,
} from "../paymentReceipt/paymentReceiptApi";
import PaymentReceipt from "../paymentReceipt/paymentReceipt";
import EmployeePayRollModal from "./employeeModal";
import { EmployeeSalarySlipModal } from "./employeeSalarySlipModal";
import PayrolSearchModal from "./payrollSearchModal";
import AdvancePayment from "../advancePayment/advancePayment";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";
import Salary from "./salary";
import OutStandingSalaryReportCard from "./outStandingReportSalarycopy";
import { EmployeeViewReceipt } from "./employeeViewReceipt";
import Heading from "../../common/Heading";
const EmployeePayRoll = () => {
  const [modalData, setModalData] = useState();
  const [outStandingBills, setOutStandingBills] = useState({
    records: [],
    totalOustandingAmount: "",
    totalRecords: "",
  });

  const [empSalary, setEmpSalary] = useState({
    records: [],
    totalOustandingAmount: "",
    totalRecords: "",
  });

  const [value, setValue] = React.useState("outstanding");

  const tabfn = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  const [open, setOpen] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [openSalarySlip, setOpenSalarySlip] = useState(false);
  //-----
  const [searchOutStandingsModal, setSearchOutStandingsModal] = useState(false);

  const [upPaidBillData, setUnPaidBillData] = useState();
  const [unPaidBill, setUnPaidBill] = useState([]);
  const data = {
    customerMobile: "",
    amount: 0,
    name: "",
  };
  const [billData, setBillData] = useState(data);
  const [billFilter, setBillFilter] = useState(null);
  const [USerObject, setUSerObject] = useState(null);

  const getUnpaid = async (param) => {
    await getUnpaidUser(param)
      .then((res) => {
        console.log("unPaid user", res?.data?.data[0]);

        setUnPaidBillData(res?.data?.data[0]);
      })
      .catch((err) => {});
  };

  const getEmpSalary = async () => {};

  //----
  const filters = [
    { name: "Amount Greater than ", value: "amountgreatethan" },
    { name: "Amount Less than ", value: "amountlessthan" },
    { name: "Amount elapsed than ", value: "dayselapsed" },
    { name: "Partially Paid ", value: "partlypaid" },
  ];

  ///---pagination functions
  const [pagination, setPagination] = useState({
    page: 1,
    total: 1,
    records: 0,
    pageSize: 24,
  });
  const [payloadGetCounterSales, setPayloadGetCounterSales] = useState({
    page: 1,
    pageSize: pagination.pageSize,
    sortBy: "",
    order: 0,
    buyerGroupId: 0,
    filter: "",
    search: "",
  });
  const [numberOfRecords, setNumberOfRecords] = useState(1);
  const handleChange = (event, value) => {
    getCounterSales(
      {
        ...payloadGetCounterSales,
        page: value,
        pageSize: pagination.pageSize,
      },
      outStandingBills,
      getCounterSalesStatement,
      setNumberOfRecords,
      setOutStandingBills
    );
    setPagination({
      ...pagination,
      page: value,
    });
  };

  const [search, setSearch] = useState("");

  const [collection, setCollection] = useState([]);
  const getDataEmpEarnPercent = async (param) => {
    await viewPaymentSlip(param)
      .then((res) => {
        console.log(
          "data======= ",
          res?.data?.data?.counterSalesHeader,
          " ",
          res?.data?.data
        );

        setCollection(res?.data?.data?.counterSalesHeader);
      })
      .catch((err) => {
        console.log("error =r ", err);
      });
  };
  const getDataEmpEarnSalary = async (param) => {
    await getEmpearningSalary(param)
      .then((res) => {
        console.log(
          "data======= ",
          res?.data?.data?.counterSalesHeader,
          " ",
          res?.data?.data
        );

        setCollection(res?.data?.data?.counterSalesHeader);
      })
      .catch((err) => {
        console.log("error =r ", err);
      });
  };
  // const [value, setValue] = useState("");
  useEffect(() => {
    console.log("search ", search);
    // getCounterSales(
    //   {
    //     employeeMasterId: USerObject?.employeeMasterId,
    //     page: pagination.page,
    //     pageSize: pagination.pageSize,
    //   },
    //   outStandingBills,
    //   getCounterSalesStatement,
    //   setNumberOfRecords,
    //   setOutStandingBills
    // );

    if (businessChooseTab?.value == "settledandpaidAmount") {
      getDataEmpEarnPercent({
        employeeMasterId: USerObject?.id,
        page: 1,
        pageSize: 1000,
      });
    } else {
      getDataEmpEarnSalary({
        employeeMasterId: USerObject?.id,
        page: 1,
        pageSize: 1000,
      });
    }
  }, [USerObject, businessChooseTab]);

  useEffect(() => {
    setSearch("");
    setUSerObject(null);
    console.log("Business Choose Tab : ", businessChooseTab?.value);
  }, [businessChooseTab?.value]);
  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={{ xs: 2, sm: 4 }}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Heading
          name={
            businessChooseTab?.value === "AdvancePayment"
              ? "Advance Payment"
              : businessChooseTab?.value === "Salary"
                ? "Salary Wise"
                : businessChooseTab?.value === "settledandpaidAmount"
                  ? "Percentage Wise"
                  : ""
          }
        />

        {/* <Grid
          item
          xs={12}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            mt: "10px",
            borderRadius: "5px",
            color: "#01008B",
            textAlign: "left",
            marginBottom: "20px",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          <Typography
            variant="h6"
            fontSize={{
              xs: "12px",
              sm: "13px",
              md: "15px",
            }}
          >
            {businessChooseTab?.value === "AdvancePayment"
              ? "Advance Payment"
              : businessChooseTab?.value === "Salary"
              ? "Salary Wise"
              : businessChooseTab?.value === "settledandpaidAmount"
              ? "Percentage Wise"
              : ""}
          </Typography>
        </Grid> */}
        <Grid xs={12}></Grid>
        {businessChooseTab?.value == "settledandpaidAmount" && (
          <React.Fragment>
            <Grid container spacing={{ xs: 1, sm: 2 }}>
              <Grid item xs={12} sm={9} sx={{ p: 0 }}>
                <TextField
                  value={search}
                  onClick={() => {
                    setSearchOutStandingsModal(true);
                  }}
                  sx={{
                    width: "100%",
                    backgroundColor: "white",
                    color: "#555555",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                  size="small"
                  id="outlined-basic-search"
                  label=" Select Employee"
                  InputLabelProps={{
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  // variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {search ? (
                          <CloseIcon
                            onClick={() => {
                              setSearch("");
                            }}
                            sx={{ cursor: "pointer" }}
                          />
                        ) : (
                          <SearchIcon
                            color="primary"
                            sx={{ cursor: "pointer" }}
                          />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid
                item
                // md={2}
                xs={12}
                sm={2}
                sx={{
                  paddingRight: "0px",
                }}
              >
                <Button
                  fullWidth
                  onClick={() => {
                    setOpen(true);
                  }}
                  sx={{
                    textTransform: "capitalize",
                    width: {
                      xs: "100%",
                    },
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // p: "10px",
                    whiteSpace: "nowrap",
                  }}
                  color="primary"
                  variant="contained"
                  aria-label="add"
                >
                  Add
                  <AddIcon sx={{ marginLeft: "6px" }} />
                </Button>
              </Grid>
            </Grid>

            <Box
              sx={{
                backgroundColor: "white",
                p: "10px",
                mt: 2,
                borderRadius: "12px",
                overflow: "auto",
                height: "75vh",
              }}
            >
              <Box
                sx={{
                  minWidth: "1050px",
                  width: "max-content",
                }}
              >
                {/* Header */}
                <Box
                  sx={{
                    display: "flex",
                    borderBottom: "1.5px solid black",
                    paddingTop: "10px",
                    padding: "10px",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      width: { sm: "140px", xs: "120px" },
                      p: "0px 22px",
                      color: "#01008B",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      // marginLeft: "30px",
                      textAlign: "left",
                    }}
                  >
                    Employee Name
                  </Box>
                  <Box
                    sx={{
                      width: { sm: "140px", xs: "100px" },
                      color: "#01008B",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                    }}
                  >
                    Processed on
                  </Box>
                  <Box
                    sx={{
                      width: "250px",
                      color: "#01008B",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                    }}
                  >
                    Payment From
                  </Box>
                  <Box
                    sx={{
                      width: "120px",
                      color: "#01008B",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "left",
                    }}
                  >
                    Payment Mode
                  </Box>
                  <Box
                    sx={{
                      width: "200px",
                      color: "#01008B",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      marginLeft: "20px",
                    }}
                  >
                    Transaction / Cheque No.
                  </Box>
                  <Box
                    sx={{
                      width: "200px",
                      color: "#01008B",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                    }}
                  >
                    Net Pay For Month
                  </Box>
                </Box>

                {/* Data rows */}
                {collection?.map((item, i) => {
                  if (item?.salaryorPercentage !== false) return null;

                  return (
                    <Box
                      key={"payamentRecpt" + i}
                      sx={{
                        display: "flex",
                        p: "6px 0",
                        borderBottom: "1px solid #ccc",
                        alignItems: "center",
                        backgroundColor: "#E8E8FF",
                        width: "max-content",
                        mb: 1,
                        mt: 1,
                        borderRadius: "8px",
                        cursor: "pointer",
                      }}
                    >
                      <Box
                        sx={{
                          width: { sm: "160px", xs: "120px" },
                          p: "0px 22px",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // marginLeft: "20px",
                          fontWeight: "medium",
                          textAlign: "left",
                        }}
                      >
                        {item?.emaployeeName || "-"}
                      </Box>
                      <Box
                        sx={{
                          width: "120px",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          textAlign: "center",
                          fontWeight: "medium",
                        }}
                      >
                        {convertDateToCustomFormat(
                          item?.createdDate?.split("T")[0],
                        )}
                      </Box>
                      <Box
                        sx={{
                          width: "250px",
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography
                            fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                            fontWeight="medium"
                          >
                            {convertDateToCustomFormat(
                              item?.fromDate?.split("T")[0],
                            )}
                          </Typography>
                          <Typography
                            fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                            fontWeight="medium"
                          >
                            To
                          </Typography>
                          <Typography
                            fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                            fontWeight="medium"
                          >
                            {convertDateToCustomFormat(
                              item?.toDate?.split("T")[0],
                            )}
                          </Typography>
                        </Stack>
                      </Box>
                      <Box
                        sx={{
                          width: "80px",
                          pl: "10px",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          textAlign: "left",
                          fontWeight: "medium",
                        }}
                      >
                        {item?.paymentMethod || "-"}
                      </Box>
                      <Box
                        sx={{
                          width: "200px",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          textAlign: "center",
                          fontWeight: "medium",
                          marginLeft: "20px",
                        }}
                      >
                        {item?.transactionDetails || "-"}
                      </Box>
                      <Box
                        sx={{
                          width: "160px",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: "medium",
                          textAlign: "right",
                        }}
                      >
                        ₹ {item?.amount?.toFixed(2) || "0.00"}
                      </Box>
                      <Box
                        sx={{
                          width: "200px",
                          pl: "70px",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: "medium",
                          textAlign: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          // sx={{ margin: "0px 8px" }}
                          onClick={() => {
                            if (setOpenView) {
                              setOpenView(true);
                              setModalData(item);
                            }
                          }}
                        >
                          View Payment Slip
                        </Button>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>

            {/* <Grid item xs={12}>
              <Divider
                sx={{
                  // width: "100%",
                  background: (theme) => theme.palette.primary.main,
                }}
              />
            </Grid>
            <Divider
              sx={{
                // width: "100%",
                background: (theme) => theme.palette.primary.main,
              }}
            /> */}

            {/* <DisplayOutStandingReport
              modalData={modalData}
              open={open}
              setOpen={setOpen}
              getRecept={() => {
                // getPaymentRec({ ...getPaymentObj });
              }}
            /> */}
            {/* -------- */}
            {/* <Grid container sx={{ pt: "10px" }}>
              <Grid item xs={4}></Grid>
              <Grid
                item
                xs={4}
                sx={{
                
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Pagination
                  count={
                    Number.isInteger(numberOfRecords / pagination.pageSize)
                      ? numberOfRecords / pagination.pageSize
                      : parseInt(numberOfRecords / pagination.pageSize) + 1
                  }
                  page={pagination.page}
                  onChange={handleChange}
                />
               
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid> */}
          </React.Fragment>
        )}
        {businessChooseTab?.value == "AdvancePayment" && <AdvancePayment />}
        {businessChooseTab?.value == "Salary" && (
          <>
            {true && (
              <React.Fragment>
                <Grid container spacing={{ xs: 1, sm: 2 }}>
                  <Grid item xs={12} sm={9} sx={{ p: 0 }}>
                    <TextField
                      value={search}
                      onClick={() => {
                        setSearchOutStandingsModal(true);
                      }}
                      sx={{
                        width: "100%",
                        backgroundColor: "white",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        color: "#555555",
                      }}
                      InputLabelProps={{
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      size="small"
                      id="outlined-basic-search"
                      label=" Select Employee"
                      // variant="outlined"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {search ? (
                              <CloseIcon
                                onClick={() => {
                                  setSearch("");
                                }}
                                sx={{ cursor: "pointer" }}
                              />
                            ) : (
                              <SearchIcon
                                color="primary"
                                sx={{ cursor: "pointer" }}
                              />
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    // md={2}
                    xs={12}
                    sm={2}
                    sx={{
                      paddingRight: "0px",
                    }}
                  >
                    <Button
                      fullWidth
                      onClick={() => {
                        setOpen(true);
                      }}
                      sx={{
                        textTransform: "capitalize",
                        width: {
                          xs: "100%",
                        },
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },

                        // p: "10px",
                        whiteSpace: "nowrap",
                      }}
                      color="primary"
                      variant="contained"
                      aria-label="add"
                    >
                      Add
                      <AddIcon sx={{ marginLeft: "6px" }} />
                    </Button>
                  </Grid>
                </Grid>

                {/* <Grid item xs={12}>
                  <Divider
                    sx={{
                      background: (theme) => theme.palette.primary.main,
                    }}
                  />
                </Grid>
                <Divider
                  sx={{
                    background: (theme) => theme.palette.primary.main,
                  }}
                /> */}

                <Box
                  sx={{
                    backgroundColor: "white",
                    p: "10px",
                    mt: 2,
                    borderRadius: "12px",
                    overflow: "auto",
                    height: "75vh",
                  }}
                >
                  <Box
                    sx={{
                      minWidth: "1050px",
                      width: "max-content",
                    }}
                  >
                    {/* Header */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        borderBottom: "1.5px solid black",
                        paddingTop: "10px",
                        padding: "10px",
                      }}
                    >
                      <Box
                        sx={{
                          width: { sm: "140px", xs: "120px" },
                          p: "0px 22px",
                          color: "#01008B",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // marginLeft: "30px",
                          textAlign: "left",
                        }}
                      >
                        Employee Name
                      </Box>
                      <Box
                        sx={{
                          width: { sm: "140px", xs: "100px" },
                          color: "#01008B",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          textAlign: "center",
                        }}
                      >
                        Processed on
                      </Box>
                      <Box
                        sx={{
                          width: "250px",
                          color: "#01008B",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          textAlign: "center",
                        }}
                      >
                        Payment From
                      </Box>
                      <Box
                        sx={{
                          width: "120px",
                          color: "#01008B",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          textAlign: "left",
                        }}
                      >
                        Payment Mode
                      </Box>
                      <Box
                        sx={{
                          width: "200px",
                          color: "#01008B",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          textAlign: "center",
                          marginLeft: "20px",
                        }}
                      >
                        Transaction / Cheque No.
                      </Box>
                      <Box
                        sx={{
                          width: "200px",
                          color: "#01008B",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          textAlign: "center",
                        }}
                      >
                        Net Pay For Month
                      </Box>
                    </Box>

                    {/* Data rows */}
                    {collection
                      ?.filter((item) => item?.salaryorPercentage !== false)
                      .map((item, i) => {
                        return (
                          <Box
                            key={"payamentRecpt" + i}
                            sx={{
                              display: "flex",
                              p: "6px 0",
                              borderBottom: "1px solid #ccc",
                              alignItems: "center",
                              backgroundColor: "#E8E8FF",
                              width: "max-content",
                              mb: 1,
                              mt: 1,
                              borderRadius: "8px",
                              cursor: "pointer",
                            }}
                          >
                            <Box
                              sx={{
                                width: { sm: "160px", xs: "120px" },
                                p: "0px 22px",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                // marginLeft: "20px",
                                fontWeight: "medium",
                                textAlign: "left",
                              }}
                            >
                              {item?.emaployeeName || "-"}
                            </Box>
                            <Box
                              sx={{
                                width: "120px",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                textAlign: "center",
                                fontWeight: "medium",
                              }}
                            >
                              {convertDateToCustomFormat(
                                item?.createdDate?.split("T")[0],
                              )}
                            </Box>
                            <Box
                              sx={{
                                width: "250px",
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                              >
                                <Typography
                                  fontSize={{
                                    xs: "12px",
                                    sm: "13px",
                                    md: "15px",
                                  }}
                                  fontWeight="medium"
                                >
                                  {convertDateToCustomFormat(
                                    item?.fromDate?.split("T")[0],
                                  )}
                                </Typography>
                                <Typography
                                  fontSize={{
                                    xs: "12px",
                                    sm: "13px",
                                    md: "15px",
                                  }}
                                  fontWeight="medium"
                                >
                                  To
                                </Typography>
                                <Typography
                                  fontSize={{
                                    xs: "12px",
                                    sm: "13px",
                                    md: "15px",
                                  }}
                                  fontWeight="medium"
                                >
                                  {convertDateToCustomFormat(
                                    item?.toDate?.split("T")[0],
                                  )}
                                </Typography>
                              </Stack>
                            </Box>
                            <Box
                              sx={{
                                width: "80px",
                                pl: "10px",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                textAlign: "left",
                                fontWeight: "medium",
                              }}
                            >
                              {item?.paymentMethod || "-"}
                            </Box>
                            <Box
                              sx={{
                                width: "200px",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                textAlign: "center",
                                fontWeight: "medium",
                                marginLeft: "20px",
                              }}
                            >
                              {item?.transactionDetails || "-"}
                            </Box>
                            <Box
                              sx={{
                                width: "160px",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                fontWeight: "medium",
                                textAlign: "right",
                              }}
                            >
                              ₹ {item?.amount?.toFixed(2) || "0.00"}
                            </Box>
                            <Box
                              sx={{
                                width: "200px",
                                pl: "70px",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                fontWeight: "medium",
                                textAlign: "center",
                              }}
                            >
                              <Button
                                variant="contained"
                                onClick={() => {
                                  setModalData(item);

                                  if (item?.salaryorPercentage === false) {
                                    setOpenView(true);
                                  } else {
                                    setOpenSalarySlip(true);
                                  }
                                }}
                              >
                                View Payment Slip
                              </Button>
                            </Box>
                          </Box>
                        );
                      })}
                  </Box>
                </Box>

                {/* <Grid
                  container
                  sx={{
                    marginX: "20px",
                  }}
                >
                  {collection?.map((item, i) => {
                    console.log("Outstanding item ", item); */}
                {/* if (
                       !item?.buyerName?.toLowerCase().includes(search.toLowerCase()) &&
                       !item?.buyerMobile
                         ?.toLowerCase()
                         .includes(search.toLowerCase()) &&
                       search.length > 0
                     ) {
                       return null;
                     } */}
                {/* if (item?.salaryorPercentage === false) {
                      return null;
                    }
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        key={"payamentRecpt" + i}
                        sx={{ p: "5px", borderRight: "3px solid #dfdfdf" }}
                      >
                        <OutStandingSalaryReportCard
                          item={item}
                          setOpen={setOpen}
                          setModalData={setModalData}
                          setOpenView={setOpenSalarySlip}
                        />
                      </Grid> */}
                {/* );
                  })}
                </Grid> */}
                {/* <DisplayOutStandingReport
              modalData={modalData}
              open={open}
              setOpen={setOpen}
              getRecept={() => {
                // getPaymentRec({ ...getPaymentObj });
              }}
            /> */}
                {/* -------- */}
                {/* <Grid container sx={{ pt: "10px" }}>
                  <Grid item xs={4}></Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ */}
                {/* display: "flex",
                      justifyContent: "center",
                    }}
                  > */}
                {/* <Pagination
                      count={
                        Number.isInteger(numberOfRecords / pagination.pageSize)
                          ? numberOfRecords / pagination.pageSize
                          : parseInt(numberOfRecords / pagination.pageSize) + 1
                      }
                      page={pagination.page}
                      onChange={handleChange}
                    />
                  </Grid> */}
                {/* <Grid item xs={4}></Grid>
                </Grid> */}
              </React.Fragment>
            )}
          </>
        )}
        {/* //------------------------ */}
      </Box>

      <EmployeePayRollModal
        modalData={modalData}
        setModalData={setModalData}
        open={open}
        setOpen={setOpen}
      />
      <EmployeeViewReceipt
        modalData={modalData}
        open={openView}
        setOpen={setOpenView}
      />

      <EmployeeSalarySlipModal
        modalData={modalData}
        open={openSalarySlip}
        setOpen={setOpenSalarySlip}
      />
      {/* <PaymentReceiptSearchModal
        searchModal={searchOutStandingsModal}
        setSearchModal={setSearchOutStandingsModal}
        unPaidBill={unPaidBill}
        getUnpaid={getUnpaid}
        setBillData={setBillData}
        search={search}
        setSearch={setSearch}

        setUnPaidBill={setUnPaidBill}
        setUnPaidBillData={setUnPaidBillData}
        setPagination={setPagination}
        billData={billData}
        callSearchApi={(searchName) => {
          setBillFilter("")
          // payloadGet CounterSales.search
          setPayloadGetCounterSales({ ...payloadGetCounterSales, search: "" })
          getCounterSales(
            {
              page: 1,
              pageSize: 10000,
              sortBy: "",
              order: 0,
              buyerGroupId: 0,
              filter: "buyername",
              search: searchName,
            },
            outStandingBills,
            getCounterSalesStatement,
            setNumberOfRecords,
            setOutStandingBills
          );
          // getPaymentRec(
          //   {
          //     // ...getPaymentObj,
          //     // page: pagination.page,
          //     // pageSize: pagination.pageSize,

          //       "page": 1,
          //       "pageSize": 10000,
          //       "filter": "buyername",//"filter": null,
          //       "search": searchName,
          //       "date": getPaymentObj?.date

          //   },
          //   getPaymentReceipt,
          //   setNumberOfRecords,
          //   setTotals,
          //   totals,
          //   setReceipts
          // );
        }}
      //  userDetail={userDetail}
      /> */}
      <PayrolSearchModal
        salaryorPercentage={
          businessChooseTab?.value == "settledandpaidAmount" ? false : true
        }
        searchModal={searchOutStandingsModal}
        setSearchModal={setSearchOutStandingsModal}
        unPaidBill={unPaidBill}
        getUnpaid={getUnpaid}
        setBillData={setBillData}
        search={search}
        setSearch={setSearch}
        setUSerObject={(data) => {
          setUSerObject(data);
        }}
        setUnPaidBill={setUnPaidBill}
        setUnPaidBillData={setUnPaidBillData}
        setPagination={setPagination}
        billData={billData}
        callSearchApi={(searchName) => {
          setBillFilter("");
          // payloadGetCounterSales.search
          setPayloadGetCounterSales({ ...payloadGetCounterSales, search: "" });

          // getPaymentRec(
          //   {
          //     // ...getPaymentObj,
          //     // page: pagination.page,
          //     // pageSize: pagination.pageSize,

          //       "page": 1,
          //       "pageSize": 10000,
          //       "filter": "buyername",//"filter": null,
          //       "search": searchName,
          //       "date": getPaymentObj?.date

          //   },
          //   getPaymentReceipt,
          //   setNumberOfRecords,
          //   setTotals,
          //   totals,
          //   setReceipts
          // );
        }}
        //  userDetail={userDetail}
      />
      {/* </Box> */}
      {/* </Drawer> */}
    </>
  );
};

export default EmployeePayRoll;
